(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pr-basque"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';root.querySelector('[data-filters]').hidden=false;root.querySelector('[data-unit-controls]').hidden=false;const cards=[...root.querySelectorAll('[data-fabric][data-length]')];function filter(){const f=root.querySelector('[name="basque-fabric"]:checked').value,l=root.querySelector('[name="basque-length"]:checked').value;let count=0;cards.forEach(c=>{c.hidden=!((f==='all'||c.dataset.fabric===f)&&(l==='all'||c.dataset.length===l));if(!c.hidden)count++});const status=root.querySelector('[data-result-count]');status.textContent=count+' '+status.dataset.label;root.querySelector('[data-no-results]').hidden=count!==0}root.addEventListener('change',e=>{if(e.target.name==='basque-fabric'||e.target.name==='basque-length')filter();if(e.target.name==='basque-unit')root.querySelectorAll('[data-cm]').forEach(td=>{td.textContent=e.target.value==='in'?(Number(td.dataset.cm)/2.54).toFixed(1)+' in':td.dataset.cm+' cm'})});root.querySelectorAll('[data-set-fabric]').forEach(a=>a.addEventListener('click',()=>{root.querySelector('[name="basque-fabric"][value="'+a.dataset.setFabric+'"]').checked=true;root.querySelector('[name="basque-length"][value="all"]').checked=true;filter()}));filter();const sticky=root.querySelector('[data-sticky]');const ob=new IntersectionObserver(es=>{es.forEach(e=>{if(e.target.classList.contains('pr-hero'))root.dataset.hero=String(e.isIntersecting);if(e.target.id==='basque-shop')root.dataset.shop=String(e.isIntersecting)});sticky.hidden=root.dataset.hero!=='false'||root.dataset.shop==='true'},{threshold:0});ob.observe(root.querySelector('.pr-hero'));ob.observe(root.querySelector('#basque-shop'))}document.querySelectorAll('[data-basque]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-basque]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pr-capri"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const cards=[...root.querySelectorAll('[data-product]')],filters=[...root.querySelectorAll('[data-filter]')];root.querySelector('[data-filters]').hidden=false;root.querySelector('[data-units]').hidden=false;const count=root.querySelector('[data-count]');function filter(value){let n=0;cards.forEach(c=>{c.hidden=value!=='all'&&c.dataset.style!==value;if(!c.hidden)n++});filters.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===value)));count.textContent=n+' '+root.dataset.countLabel;}filters.forEach(b=>b.addEventListener('click',()=>filter(b.dataset.filter)));root.querySelectorAll('[data-pick]').forEach(a=>a.addEventListener('click',()=>filter(a.dataset.pick)));root.addEventListener('change',e=>{if(!e.target.matches('[data-variant]'))return;const s=e.target,c=s.closest('[data-product]'),o=s.selectedOptions[0],url=s.dataset.base.split('?')[0]+'?variant='+encodeURIComponent(s.value);c.querySelector('[data-product-link]').href=url;c.querySelector('.cp-product-photo').href=url;c.querySelector('[data-price]').textContent=o.dataset.price});root.querySelectorAll('[data-unit]').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('[data-unit]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));root.querySelectorAll('[data-cm]').forEach(td=>td.textContent=b.dataset.unit==='in'?(Number(td.dataset.cm)/2.54).toFixed(1)+' in':td.dataset.cm+' cm')}));filter('all');if('IntersectionObserver'in window){const sticky=root.querySelector('[data-sticky]');const state={hero:true,shop:false,final:false};const ob=new IntersectionObserver(es=>{es.forEach(e=>{state[e.target.dataset.visibility]=e.isIntersecting});sticky.hidden=state.hero||state.shop||state.final});[['.cp-hero','hero'],['#capri-shop','shop'],['.cp-final','final']].forEach(([s,k])=>{const el=root.querySelector(s);el.dataset.visibility=k;ob.observe(el)})}}document.querySelectorAll('[data-capri]').forEach(init);document.addEventListener('shopify:section:load',e=>{if(e.target.matches('[data-capri]'))init(e.target);e.target.querySelectorAll('[data-capri]').forEach(init)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pr-ecovero"] && !Shopify.designMode) return;
  try {
    
(()=>{
function init(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const cards=[...root.querySelectorAll('[data-family]')],filters=root.querySelector('[data-filters]'),count=root.querySelector('[data-result-count]'),more=root.querySelector('[data-more-wrap]'),none=root.querySelector('[data-no-results]');
 const necklines={cap:'boat',batwing:'crew',mesh:'crew',off:'off',double_v:'v',swing:'scoop',box_pleat:'scoop',easy_cap:'crew',easy_half:'crew',slim_half:'crew',easy_u:'scoop',slim_u:'scoop',wide_neck:'boat',one_shoulder:'off',easy_singlet:'scoop',slim_singlet:'scoop',sleeveless_crew:'crew',chiffon:'v',easy_long:'crew',slim_long:'crew',zip_polo:'polo'};
 cards.forEach(c=>c.dataset.neck=necklines[c.dataset.style]||'');
 let limit=6;
 const value=key=>root.querySelector('[data-filter="'+key+'"]:checked').value;
 function apply(){const matching=cards.filter(c=>(value('neck')==='all'||c.dataset.neck===value('neck'))&&(value('sleeve')==='all'||c.dataset.sleeve===value('sleeve'))&&(value('fit')==='all'||c.dataset.fit===value('fit')));cards.forEach(c=>c.hidden=true);matching.slice(0,limit).forEach(c=>c.hidden=false);count.textContent=count.dataset.show+' '+Math.min(limit,matching.length)+' '+count.dataset.of+' '+matching.length+' '+(matching.length===1?count.dataset.single:count.dataset.match);more.hidden=matching.length<=limit;none.hidden=matching.length!==0;}
 function set(key,v){root.querySelector('[data-filter="'+key+'"][value="'+v+'"]').checked=true;}
 filters.hidden=false;filters.addEventListener('change',()=>{limit=6;apply()});root.querySelector('[data-more]').addEventListener('click',()=>{const oldLimit=limit;limit+=6;apply();const newly=cards.filter(c=>!c.hidden)[oldLimit];if(newly){const link=newly.querySelector('.ec-card-photo:not([hidden])');if(link&&link.tagName==='A')link.focus({preventScroll:true});}});
 root.querySelector('[data-reset]').addEventListener('click',()=>{set('neck','all');set('sleeve','all');set('fit','all');limit=6;apply()});
 cards.forEach(card=>{card.querySelector('[data-colours]').hidden=false;card.querySelectorAll('[data-colour]').forEach(button=>button.addEventListener('click',()=>{card.querySelectorAll('[data-colour]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));card.querySelectorAll('[data-photo]').forEach(p=>p.hidden=p.dataset.photo!==button.dataset.colour);card.querySelectorAll('[data-offer]').forEach(p=>p.hidden=p.dataset.offer!==button.dataset.colour);}));});
 root.querySelectorAll('[data-go-fit]').forEach(a=>a.addEventListener('click',()=>{set('neck','all');set('sleeve','all');set('fit',a.dataset.goFit);limit=6;apply()}));
 root.querySelectorAll('[data-go-style]').forEach(a=>a.addEventListener('click',()=>{set('neck','all');set('sleeve','all');set('fit','all');const index=cards.findIndex(c=>c.dataset.style===a.dataset.goStyle);limit=Math.max(6,Math.ceil((index+1)/6)*6);apply()}));
 apply();
 if('IntersectionObserver'in window){const sticky=root.querySelector('[data-sticky]'),state={hero:true,shop:false,final:false};const observer=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.target.classList.contains('ec-hero'))state.hero=e.isIntersecting;if(e.target.classList.contains('ec-finder'))state.shop=e.isIntersecting;if(e.target.classList.contains('ec-final'))state.final=e.isIntersecting});sticky.hidden=state.hero||state.shop||state.final});root.querySelectorAll('.ec-hero,.ec-finder,.ec-final').forEach(el=>observer.observe(el));}
}
document.querySelectorAll('[data-eco]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-eco]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pr-sailor"] && !Shopify.designMode) return;
  try {
    
(function(){
 function init(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  root.querySelectorAll('[data-variant]').forEach(function(select){select.addEventListener('change',function(){var card=select.closest('[data-product]'),option=select.selectedOptions[0],base=select.dataset.base;card.querySelector('[data-price]').textContent=option.dataset.price;card.querySelectorAll('[data-product-link]').forEach(function(a){a.href=base+'?variant='+encodeURIComponent(select.value)});});});
  root.querySelectorAll('[data-units]').forEach(function(button){button.addEventListener('click',function(){var inches=button.dataset.units==='in';root.querySelectorAll('[data-units]').forEach(function(b){b.setAttribute('aria-pressed',String(b===button))});root.querySelectorAll('[data-cm]').forEach(function(cell){cell.textContent=inches?(Number(cell.dataset.cm)/2.54).toFixed(1):cell.dataset.cm});root.querySelectorAll('[data-unit-label]').forEach(function(label){label.textContent=inches?'in':'cm'});});});
 }
 document.querySelectorAll('[data-sailor]').forEach(init);
 document.addEventListener('shopify:section:load',function(e){e.target.querySelectorAll('[data-sailor]').forEach(init)});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pr-solution-dressing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pr-solution-dressing')) {
    customElements.define('pr-solution-dressing', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('[data-filters]');
        this.grid = this.querySelector('[data-products]');
        this.cards = [...this.querySelectorAll('[data-product]')];
        this.selects = [...this.querySelectorAll('[data-filter]')];
        this.limit = 8;
        this.sizeOrder = ['XXS','XS','S','M','L','XL','2XL','XXL','3XL','XXXL'];
        this.values = (card,key) => (card.dataset[key] || '').split('|').map(v => v.trim()).filter(Boolean);
        this.selects.forEach(select => {
          const key = select.dataset.filter;
          const values = [...new Set(this.cards.flatMap(card => this.values(card,key)))];
          values.sort((a,b) => key === 'size' && this.sizeOrder.includes(a) && this.sizeOrder.includes(b) ? this.sizeOrder.indexOf(a)-this.sizeOrder.indexOf(b) : a.localeCompare(b,undefined,{numeric:true}));
          values.forEach(value => select.add(new Option(value,value)));
          select.parentElement.hidden = values.length < 2 && key !== 'size';
        });
        this.form.hidden = false;
        this.form.addEventListener('submit', event => event.preventDefault());
        this.form.addEventListener('change', () => { this.limit=8; this.update(); });
        this.form.addEventListener('reset', event => {
          event.preventDefault();
          this.selects.forEach(select => { select.value=''; });
          this.querySelector('[data-sort]').value='recommended';
          this.querySelector('[data-available]').checked=true;
          this.limit=8;
          this.update();
        });
        this.querySelectorAll('[data-reset]').forEach(button => button.addEventListener('click', () => this.form.reset()));
        this.querySelector('[data-more]').addEventListener('click', () => {
          const previous=this.limit;
          this.limit+=8;
          const matches=this.update();
          matches[previous]?.querySelector('a')?.focus({preventScroll:true});
        });
        this.querySelectorAll('[data-preset-field]').forEach(link => link.addEventListener('click', () => {
          this.selects.forEach(select => { select.value = select.dataset.filter === link.dataset.presetField ? link.dataset.presetValue : ''; });
          this.form.querySelector('[data-available]').checked=true;
          this.limit=8;
          this.update();
          this.querySelector('.pr-sol__explorer h2').focus({preventScroll:true});
        }));
        this.setupBasket();
        this.update();
      }
      setupBasket() {
        this.basket=this.querySelector('[data-basket-dialog]');
        this.basketForm=this.querySelector('[data-basket-form]');
        this.variantSelect=this.querySelector('[data-basket-variant]');
        this.basketStatus=this.querySelector('[data-basket-status]');
        this.basketError=this.querySelector('[data-basket-error]');
        this.basketSubmit=this.querySelector('[data-basket-submit]');
        this.basketLink=this.querySelector('[data-basket-link]');
        this.savedVariants=new Map();
        this.chooseTitle=this.basket.querySelector('h2').textContent;
        this.querySelectorAll('[data-quick-add]').forEach(button => {
          button.hidden=false;
          button.addEventListener('click',()=>this.openBasket(button));
        });
        this.querySelectorAll('[data-basket-close]').forEach(button => button.addEventListener('click',()=>{
          if (!this.basketBusy) this.basket.close();
        }));
        this.basket.addEventListener('cancel',event=>{ if(this.basketBusy) event.preventDefault(); });
        this.basket.addEventListener('close',()=>this.basketTrigger?.focus({preventScroll:true}));
        this.basketForm.addEventListener('submit',event=>{
          event.preventDefault();
          if (this.basketForm.reportValidity()) this.addToBasket();
        });
      }
      openBasket(button) {
        if(this.basketBusy) return;
        this.basketTrigger=button;
        this.quickProduct=button.closest('[data-quick-product]');
        this.variantSelect.replaceChildren(this.quickProduct.querySelector('template').content.cloneNode(true));
        this.querySelector('[data-basket-product]').textContent=this.quickProduct.dataset.title;
        this.basketStatus.textContent='';
        this.basketError.textContent='';
        this.basketLink.hidden=true;
        this.basketForm.hidden=false;
        this.basket.querySelector('h2').textContent=this.chooseTitle;
        const size=this.querySelector('[data-filter="size"]').value;
        const options=[...this.variantSelect.options].filter(option=>option.value && !option.disabled);
        const matching=size ? options.filter(option=>option.dataset.size===size) : [];
        const remembered=!size && options.find(option=>option.value===this.savedVariants.get(this.quickProduct.dataset.quickProduct));
        const selected=size ? (matching.length===1 ? matching[0] : null) : remembered || (this.quickProduct.dataset.default==='true' ? options[0] : null);
        this.variantSelect.value=selected?.value || '';
        this.basket.showModal();
        if(selected) this.addToBasket();
        else this.variantSelect.focus();
      }
      async addToBasket() {
        if(this.basketBusy || !this.variantSelect.value) return;
        const option=this.variantSelect.selectedOptions[0];
        if(option.disabled) return;
        const variantId=option.value;
        this.basketBusy=true;
        this.basketSubmit.disabled=true;
        this.variantSelect.disabled=true;
        this.querySelectorAll('[data-basket-close]').forEach(button=>{button.disabled=true;});
        this.basketError.textContent='';
        this.basketStatus.textContent=this.basket.dataset.adding;
        let added=false;
        try {
          const root=this.basket.dataset.root.replace(/\/?$/,'/');
          const response=await fetch(root+'cart/add.js',{
            method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
          });
          const result=await response.json();
          if(!response.ok) throw new Error(result.description || result.message || this.basket.dataset.error);
          added=true;
          this.savedVariants.set(this.quickProduct.dataset.quickProduct,variantId);
          this.basketForm.hidden=true;
          this.basket.querySelector('h2').textContent=this.basket.dataset.added;
          this.basketStatus.textContent=option.textContent;
          this.basketLink.hidden=false;
          this.basketLink.focus();
          try {
            const cartResponse=await fetch(root+'cart.js',{headers:{'Accept':'application/json'}});
            if(cartResponse.ok) {
              const cart=await cartResponse.json();
              document.querySelectorAll('.js-cart-count').forEach(count=>{count.textContent=String(cart.item_count);});
              const config=document.getElementById('cart-config');
              if(config && window.Shopify?.theme?.ajaxCart?.updateView) window.Shopify.theme.ajaxCart.updateView(JSON.parse(config.textContent),cart);
            }
          } catch(refreshError) {}
        } catch(error) {
          if(!added) {
            this.basketStatus.textContent='';
            this.basketError.textContent=error.message==='Failed to fetch' ? this.basket.dataset.error : error.message;
            this.basketLink.hidden=false;
          }
        } finally {
          this.basketBusy=false;
          this.basketSubmit.disabled=false;
          this.variantSelect.disabled=false;
          this.querySelectorAll('[data-basket-close]').forEach(button=>{button.disabled=false;});
        }
      }
      update() {
        const availableOnly=this.querySelector('[data-available]').checked;
        const matches=this.cards.filter(card => (!availableOnly || card.dataset.available==='true') && this.selects.every(select => !select.value || this.values(card,select.dataset.filter).includes(select.value)));
        const sort=this.querySelector('[data-sort]').value;
        if (sort==='price-asc') matches.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
        if (sort==='price-desc') matches.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
        this.cards.forEach(card => { card.hidden=true; });
        matches.forEach((card,index) => { this.grid.append(card); card.hidden=index>=this.limit; });
        const visible=Math.min(matches.length,this.limit);
        this.querySelector('[data-status]').textContent=this.dataset.countLabel.replace('[shown]',String(visible)).replace('[total]',String(matches.length));
        this.querySelector('[data-empty]').hidden=matches.length>0;
        this.querySelector('[data-more]').hidden=matches.length<=this.limit;
        return matches;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pr-vneck"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.vneckReady) return;
    root.dataset.vneckReady = 'true';
    root.querySelectorAll('[data-vn-card]').forEach(card => {
      card.querySelectorAll('[data-vn-colour]').forEach(button => {
        button.addEventListener('click', () => {
          const id = button.dataset.vnColour;
          card.querySelectorAll('[data-vn-colour]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
          card.querySelectorAll('[data-vn-panel]').forEach(panel => { panel.hidden = panel.dataset.vnPanel !== id; });
          card.querySelectorAll('[data-vn-photo]').forEach(photo => { photo.hidden = photo.dataset.vnPhoto !== id; });
          card.querySelector('[data-vn-colour-name]').textContent = button.dataset.vnName;
        });
      });
      card.querySelectorAll('[data-vn-size]').forEach(select => {
        select.addEventListener('change', () => {
          const option = select.selectedOptions[0];
          const panel = select.closest('[data-vn-panel]');
          panel.querySelector('[data-vn-price]').textContent = option.dataset.price;
          panel.querySelector('[data-vn-stock]').textContent = option.dataset.stock;
          panel.querySelector('[data-vn-product-link]').href = option.dataset.url;
          card.querySelectorAll('[data-vn-photo]').forEach(photo => {
            if (photo.dataset.vnPhoto === select.dataset.productId) photo.href = option.dataset.url;
          });
        });
      });
    });
  }
  document.querySelectorAll('[data-vneck]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-vneck]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pr-waterfall"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';root.querySelector('[data-units]').hidden=false;root.addEventListener('change',e=>{if(!e.target.matches('[data-variant]'))return;const s=e.target,c=s.closest('[data-product]'),o=s.selectedOptions[0];c.querySelector('[data-product-link]').href=s.dataset.base+(s.value?'?variant='+encodeURIComponent(s.value):'');if(o.dataset.price)c.querySelector('[data-price]').textContent=o.dataset.price});root.querySelectorAll('[data-unit]').forEach(b=>b.addEventListener('click',()=>{root.querySelectorAll('[data-unit]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));root.querySelectorAll('[data-cm]').forEach(td=>td.textContent=b.dataset.unit==='in'?(Number(td.dataset.cm)/2.54).toFixed(1)+' in':td.dataset.cm+' cm')}));if('IntersectionObserver' in window){const sticky=root.querySelector('[data-sticky]');const observer=new IntersectionObserver(es=>{es.forEach(e=>{if(e.target.classList.contains('wf-hero'))root.dataset.hero=String(e.isIntersecting);if(e.target.id==='waterfall-shop')root.dataset.shop=String(e.isIntersecting);if(e.target.classList.contains('wf-final'))root.dataset.final=String(e.isIntersecting)});sticky.hidden=root.dataset.hero!=='false'||root.dataset.shop==='true'||root.dataset.final==='true'},{threshold:0});['.wf-hero','#waterfall-shop','.wf-final'].forEach(s=>observer.observe(root.querySelector(s)))}}document.querySelectorAll('[data-waterfall]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-waterfall]').forEach(init))})();

  } catch(e) { console.error(e); }
})();
})();
